import { JSXElement, mergeProps, splitProps } from 'solid-js';
import { twMerge } from 'tailwind-merge';
import { ark, HTMLArkProps } from '@ark-ui/solid';

type TableProps = HTMLArkProps<'table'> & {
  variant?: 'primary' | 'unstyled' | 'ghost';
};

export default function Table(props: TableProps): JSXElement {
  const merged = mergeProps(
    {
      class: '',
      variant: 'primary'
    },
    props
  );
  const variantClass = merged.variant === 'unstyled' ? '' : merged.variant;
  const [split, rest] = splitProps(merged, ['class', 'children', 'variant']);
  return (
    <ark.table
      class={twMerge(variantClass, `w-full`, split.class)}
      {...rest}
    >
      {split.children}
    </ark.table>
  );
}
